import { createContext, useContext, useState, PropsWithChildren } from "react";

type SuccessContextType = {
  success: string | null;
  setSuccess: (msg: string | null) => void;
};

const SuccessContext = createContext<SuccessContextType | undefined>(undefined);

export function SuccessProvider({ children }: PropsWithChildren) {
  const [success, setSuccess] = useState<string | null>(null);
  return (
    <SuccessContext.Provider value={{ success, setSuccess }}>
      {children}
    </SuccessContext.Provider>
  );
}

export function useSuccess() {
  const context = useContext(SuccessContext);
  if (!context) throw new Error("useSuccess must be used within SuccessProvider");
  return context;
}
